import { SimpleGrid } from '@chakra-ui/react'
import React from 'react'
import DashboardItem from '../../../components/DashboardItem'
import { MonthlyReport } from '../../../store/useStore'
import { dashboardItems } from '../utils/dashboardItems'
import { statusCalculators } from '../utils/statusCalculations'

interface DashboardGridProps {
  month: string
  report: MonthlyReport | undefined
  stagesCount: number
}

const DashboardGrid: React.FC<DashboardGridProps> = ({
  month,
  report,
  stagesCount,
}) => {
  return (
    <SimpleGrid minChildWidth='300px' spacing={2}>
      {dashboardItems.map((item) => {
        const statusCalculator =
          statusCalculators[item.step as keyof typeof statusCalculators]
        let status = statusCalculator(report)

        // Special handling for step 12 title to include stagesCount
        let title = item.title
        if (item.step === 12) {
          title = `Core Education & ${stagesCount} Steps`
        }

        return (
          <DashboardItem
            key={item.step}
            to={`/report/${month}/${item.path}`}
            title={title}
            subtitle={item.subtitle}
            status={status}
          />
        )
      })}
    </SimpleGrid>
  )
}

export default DashboardGrid
